import React from 'react';
import {Card} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";

let commonStrings = new LocalizedStrings(common_strings);

const ClientAppComponent = (props) => {

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    };

    localize();

    function openAndroidApp(){
        window.open(`https://play.google.com/store/apps/details?id=com.openclient`, "_blank")
    }

    function openIOSApp(){
        window.open(`https://apps.apple.com/us/app/open-client/id1478628247`, "_blank")
    }

    function openWebApp(e) {
        e.preventDefault();
        window.open('https://clientopen.com', 'blank')
    }

    return (
        <Card
            className="bg-yellowopen mt-4"
        >
            <div>
                <div className="py-3 px-3 text-center">
                    <i style={{color: "white", fontSize: 50}} className="fas fa-mobile-alt"/>

                    <h4 className="mt-4 text-white">
                        {commonStrings.open.download_client_app}
                    </h4>

                </div>
            </div>
            <div className="text-center align-content-center" style={{cursor: 'pointer'}}>
                <img
                    alt="..."
                    width={130}
                    onClick={e => openWebApp(e)}
                    src={localeHelpers.webIcon()}
                />
            </div>
            <div className="text-center align-content-center" style={{cursor: 'pointer'}}>
                <img
                    alt="..."
                    width={130}
                    onClick={e => openIOSApp(e)}
                    src={localeHelpers.iosIcon()}
                />
            </div>
            <div className="text-center align-content-center mt-2 mb-2" style={{cursor: 'pointer'}}>
                <img
                    alt="..."
                    width={150}
                    onClick={e => openAndroidApp(e)}
                    src={localeHelpers.androidIcon()}
                />
            </div>
        </Card>
    );
};

export default ClientAppComponent;